//------------------------------------------------------------------------------
// 環境設定ファイル NESクラウド環境 (nes1)
//------------------------------------------------------------------------------
const FRONT_DOMAIN ='int.web.dev.tkts.denryoku-nes.com';
export default {
  'logger': false,
  'consolelog': true,
  'showLogout': true,

  // バックエンドAPI
  'API_URL': 'https://int.api.dev.tkts.denryoku-nes.com/',

  // メールドメイン
  'MAIL_DOMAIN': 'tkts.tkts-nes.com',

  // トップに戻る
  'BACK_TO_ROOT': '/',

  // ログインやり直し
  'BACK_TO_LOGIN': '/logout',

  // Wijmoライセンス
  /* eslint-disable max-len */
  'WIJMO_LICENSE_KEY': `${FRONT_DOMAIN},513946179883746#B0NIJxmZiwiIyYXNyAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34zdYF7dsZWZHFne8gnNWl6Y8p5Mlp4TThEcxEnNUhmc6hGdLhGMIVjaphkVUp4UJhFaFVnYitkVYlGdDBHTm3yam9EdDZDWhRDN7FWQVJTUixkWSdkWVJkZ7MVQFREdjFGbDpHZulUS4VEUz84KaRUS6xUZlljUXZ6KxRVUDhnYKVzZ4V7U4QTO4EmTltCNG5WRZVWN5gUZoB5UwFVQENzMCV5awMnV4cnS5h4YspUbmN7U0p5SlNWValnQGdzKsFEU0JUenhUNzckTqpFSUlnbhtUSOZ6KWtkeCl7K8gFZxVHRRljNMVlWINHMvMjZMJGNHp5bjR4U5gTWh54UzRnWwhTdrlkMyp6UndnQ6R6byY4RNRXS7t6RtpEWkJFbupVWDRHZvMTS7UjeqpEdXJ4RRN4VSJEbzdDVKN5ZLJDM7RnV5EjQwl5LqdlSJlFexZWOl3yc9tkI0IyUiwiI9UDOzYUOFdjI0ICSiwCOyIjNzUTMyMTM0IicfJye=#Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiI7UjNxIDMgUDMyAjNyAjMiojI4J7QiwiIt36YuMXZu5Sdr3Wey9WZk9yc4tGduYXZk9iYldnL49WaiojIz5GRiwiI+S09ayL9Pyb9qCq9/K882O88ZO88OO88kK88zO88nO887K882O88lO88qO883K88DVkTiojIh94QiwiI6QzNzgDO9cTM6QTOzETNiojIklkIs4BXxp`,

  // Cognite認証設定
  'amplify': {
    Auth: {
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_5Hrkpht7u',
      userPoolWebClientId: '206gm5rvjk3vjhpp3290pj8cja',
      mandatorySignIn: false,
    },
  },
};
